import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
        margin: "normal",
        size: "small",
      },
      styleOverrides: {
        root: {
          marginTop: "6px",
          marginBottom: "6px",
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          height: "34px",
          fontSize: "14px",

          "& input": {
            padding: "6px 8px !important",
          },

          "& legend": {
            display: "none",
          },
          "& fieldset": {
            top: 0,
          },

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ccc",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#888",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#454545",
          },
        },
      },
    },

    MuiInputLabel: {
      defaultProps: {
        shrink: true,
      },
      styleOverrides: {
        root: {
          fontSize: "14px",
        },
        shrink: {
          transform: "translate(12px, -11px) scale(0.80) !important",
          backgroundColor: "white",
          padding: "1 3px",
          zIndex: 10,
        },
      },
    },
  },
});

export default theme;
